export default __webpack_public_path__ + "static/media/gabi.8d189655.jpg";